import {
  Accordion,
  AccordionItem,
  Card,
  CardBody,
  Link,
} from "@nextui-org/react";
import { MetaFunction } from "react-router";
import { BiMessageDetail, BiPhone } from "react-icons/bi";
import Navbar from "~/components/navbar";
import { OG_METADATA } from "~/utils/constants";

export const meta: MetaFunction = () => {
  return [
    {
      title: "Contact",
    },
    {
      name: "description",
      content:
        "Find help and support for tribe.best. Our Support team provide answers on all types of issues.",
    },
    ...OG_METADATA,
    {
      "script:ld+json": {
        "@context": "https://schema.org",
        "@type": "Organization",
        name: "tribe.best",
        url: "https://tribe.best",
        logo: "https://tribe.best/apple-touch-icon.png",
        email: "hello@tribe.best",
        description:
          "tribe.best is a next-generation service discovery platform that connects quality-conscious consumers with India's finest service experts through an intelligent, AI-powered marketplace.",
        foundingDate: "2023",
        telephone: "+916360004054",
        contactPoint: [
          {
            "@type": "ContactPoint",
            email: "hello@tribe.best",
            telephone: "+916360004054",
          },
        ],
        legalName: "Speakleap Technologies Private Limited",
        numberOfEmployees: {
          "@type": "QuantitativeValue",
          value: 4,
        },
        address: [
          {
            "@type": "PostalAddress",
            streetAddress:
              "1st floor, SPD Plaza, 52, Jyoti Niwas College Rd, Koramangala",
            addressLocality: "Bengaluru",
            addressRegion: "Karnataka",
            postalCode: "560034",
            addressCountry: "India",
          },
        ],
      },
    },
  ];
};

export default function ContactUs() {
  return (
    <div className="w-full mx-auto">
      <Navbar />
      <section className="w-full relative bg-primary-50">
        <div className="max-w-7xl mx-auto px-4 md:px-8 py-16 flex flex-col items-center">
          <h1 className="text-lg md:text-xl font-medium text-primary">
            Contact
          </h1>
          <h2 className="text-center text-3xl md:text-4xl font-medium">
            Hello 👋, How can we help?
          </h2>
        </div>
      </section>
      <section>
        <div className="max-w-4xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-4 px-4 md:px-8 py-16">
          <Card className="">
            <CardBody className="p-6">
              <div className="bg-primary-100 rounded-full aspect-square flex justify-center items-center size-12 mb-6">
                <BiPhone className="size-6 text-primary-500" />
              </div>
              <h4 className="text-xl font-semibold mb-2">Give us a call</h4>
              <Link href="tel:+916360004054" target="_blank" underline="hover">
                +91 6360-004054
              </Link>
              <p className="text-default-500">Mon-Fri from 9am to 6pm IST</p>
            </CardBody>
          </Card>
          <Card className="">
            <CardBody className="p-6">
              <div className="bg-primary-100 rounded-full aspect-square flex justify-center items-center size-12 mb-6">
                <BiMessageDetail className="size-6 text-primary-500" />
              </div>
              <h4 className="text-xl font-semibold mb-2">Send us an email</h4>
              <Link
                href="mailto:hello@tribe.best"
                target="_blank"
                underline="hover"
              >
                hello@tribe.best
              </Link>
              <p className="text-default-500">
                We&apos;ll respond within 24 hours
              </p>
            </CardBody>
          </Card>
        </div>
      </section>
      <section className="relative bg-gradient-to-t from-primary-50 to-background">
        <div className="flex flex-col items-center max-w-3xl mx-auto px-4 md:px-8 py-16 gap-16">
          <h3 className="text-3xl md:text-4xl font-medium">FAQs</h3>
          <Accordion variant="splitted">
            <AccordionItem key="find" title="How do I find a service expert?">
              You can search for service experts by name or category using the
              search bar at the <Link href="/">home page</Link>.
            </AccordionItem>
            <AccordionItem
              key="connect"
              title="How do I connect with an expert?"
            >
              You can connect with an expert by clicking on the &apos;Smart
              Connect&apos; button on the service expert&apos;s profile page.
              Additionally, you can also connect them on WhatsApp by clicking on
              the &apos;WhatsApp&apos; button on the service expert&apos;s
              profile page.
            </AccordionItem>
            <AccordionItem
              key="privacy"
              title="Do you share my information with the service expert?"
            >
              No, we do not share your information with the service expert. Your
              information is private and secure. Only that information which you
              choose to share with the service expert is shared with them.
            </AccordionItem>
            <AccordionItem
              key="register"
              title="I am an expert, how do I register?"
            >
              You can register as an expert by going here:
              <br />
              <Link href="/become-expert" underline="hover">
                Become an Expert
              </Link>
            </AccordionItem>
            <AccordionItem
              key="paid"
              title="Is connecting with an expert free?"
            >
              Yes, connecting with an expert is free. tribe.best does not charge
              you for connecting with an expert, you can directly negotiate the
              best price with the expert.
            </AccordionItem>
          </Accordion>
        </div>
      </section>
    </div>
  );
}
